import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useFormik } from "formik";
import * as Yup from "yup";
import Spinner from "react-bootstrap/Spinner";
import close from '../../assets/svg/close.svg'
import config from '../../Helpers/config.json'
import './style.css'
import { useNavigate } from "react-router-dom";
import { credential } from "../../constant/credential";
import ErrorToast from "../../utills/error-toast";
import SuccessToast from "../../utills/success-toast";

const LoginModal = ({ show, onHide, setIsLoggenIn, setShowForgotPopup, setShowSignupPopup, closeAll, setShowAddProfileModal }) => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid Email address")
        .required("Email is Required"),
      password: Yup.string().required("Password Required"),
    }),
  });

  const openForgotModal = () => {
    onHide()
    setShowSignupPopup(false)
    setShowForgotPopup(true)
  }

  const openSignupModal = () => {
    onHide()
    setShowForgotPopup(false)
    setShowSignupPopup(true)
  }

  const login = () => {
    // if (formik.values.email === credential.email && formik.values.password === credential.password) {
    //   localStorage.setItem('token', formik.values.email)
    //   localStorage.setItem('uid', formik.values.email)
    //   localStorage.setItem('role', 'ADMIN')
    //   setLoading(false)
    //   closeAll()
    //   setIsLoggenIn(true)
    //   navigate('/')
    //   return
    // }
    setLoading(true)
    fetch(`${config['baseUrl2']}v1/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: formik.values.email,
        password: formik.values.password
      })
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          localStorage.setItem('email', formik.values.email);
          localStorage.setItem('data', JSON.stringify(data));
          localStorage.setItem('token', data?.token);
          localStorage.setItem('uid', data?.uid);
          localStorage.setItem('role', data?.role);
          fetch(`${config['baseUrl2']}profile/listProfiles?userId=${data.uid}`, {
            method: 'GET',
            headers: { 'content-type': 'application/json' },
          })
            .then((res) => res.json())
            .then((res) => {
              if (res.success === true) {
                if (res?.profiles.length > 0) {
                  setLoading(false)
                  closeAll()
                  setIsLoggenIn(true)
                  navigate('/')
                } else {
                  setLoading(false)
                  setIsLoggenIn(true)
                  closeAll()
                  setShowAddProfileModal(true)
                }
              } else {
                setLoading(false)
              }
            });
        } else {
          setLoading(false)
          if (data.message === "Email not verified") {
            ErrorToast('Email not verified');
          } else {
            ErrorToast(data.message || 'Login Failed');
          }
          console.log('Login Failed:', data.message);
        }
      })
      .catch((error) => {
        console.log('Error:', error);
        setLoading(false);
        ErrorToast(`Error: ${error.message}`);
      });
  };


  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      className="login-modal"
      centered
    >
      <span onClick={closeAll}>
        <img src={close} alt="" className="close-icon" />
      </span>
      <Modal.Body className="d-flex flex-column align-items-center ">
        <div className="w-100 header-custom">
          <p>Login</p>
        </div>
        <Form.Group className="mb-3 input-field">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="text"
            placeholder="Email"
            id="email"
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isInvalid={!!formik.touched.email && !!formik.errors.email}
          />
          <Form.Control.Feedback type="invalid">
            {formik.errors.email}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className="mb-3 input-field">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="password"
            placeholder="Password"
            id="password"
            name="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isInvalid={!!formik.touched.password && !!formik.errors.password}
          />
          <Form.Control.Feedback type="invalid">
            {formik.errors.password}
          </Form.Control.Feedback>
        </Form.Group>
        <div className="login-navigate-ref">
          <p className="prominent-text" onClick={openForgotModal}>Forgot Password?</p>
          <p>Don't have an account? <span className="prominent-text" onClick={openSignupModal}>Create here!</span></p>
        </div>
        <Button className="auth-action-btn" onClick={login} variant="primary">
          {loading ? <Spinner animation="border" size={5} /> : "Login"}
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default LoginModal;
